import authErrors from 'features/auth/constants/errors';

export default function handleErrorMessage (err){
  const errors = err?.data?.errors || [];
  const error = errors[0];
  if (error?.detail?.indexOf(' ') >= 0) {
    const detail = error.detail.replaceAll(' ', '.');
    const pointer = error.source.pointer.split('/');
    return authErrors[`${pointer[pointer.length - 1]}.${detail}`];
  } else {
    return authErrors[error?.detail] ?? 'common.error.message';
  }
}